import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  Link,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";

const useStyle = makeStyles((theme) => ({
  modalContainer: {
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  modalTitle: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: "20px",
  },
  closeButton: {
    color: theme.palette.text.secondary,
  },
}));

interface BulkEditUserModal {
  open: boolean;
  handleClose: () => void;
  failedUsers: string[];
}

export const BulkUserErrorModal = (props: BulkEditUserModal) => {
  const classes = useStyle();

  return (
    <>
      <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="bulk-user-error-modal">
        <Card sx={{ width: "500px" }} className={classes.modalContainer}>
          <CardHeader
            sx={{ padding: "16px 24px" }}
            title={
              <Typography
                id="bulk-user-error-modal-title"
                variant="h6"
                className={classes.modalTitle}>
                User creation failed
              </Typography>
            }
            action={
              <Tooltip
                placement="bottom-end"
                title="Close"
                arrow
                role="tooltip"
                describeChild>
                <IconButton
                  onClick={() => {
                    props.handleClose();
                  }}
                  aria-label="close edit user account"
                  className={classes.closeButton}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            }
          />
          <Divider />
          <CardContent
            sx={{
              padding: "24px 32px",
              maxHeight: "449px",
              overflow: "auto",
            }}>
            <Typography variant="body1">
              The following user(s) could not be created and may already exist:
            </Typography>
            <Typography variant="body1" style={{ margin: "16px 0px" }}>
              {props.failedUsers.map((user, index) => {
                return (
                  <span key={index}>
                    <b>{user}</b>
                    {index !== props.failedUsers.length - 1 ? ", " : ""}
                  </span>
                );
              })}
            </Typography>
            <Typography variant="body1">
              Please try a new email address for the user(s).
            </Typography>
          </CardContent>
          <Divider />
          <CardActions sx={{ padding: "24px 48px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                width: "100%",
              }}>
              <Link onClick={props.handleClose} underline="none">
                <Button
                  size="medium"
                  variant="contained"
                  sx={{
                    fontSize: "1.25rem",
                    borderRadius: "16px",
                    width: "109px",
                    height: "62px",
                    padding: "0px",
                    "&:hover": {
                      transform: "none",
                    },
                  }}>
                  Ok
                </Button>
              </Link>
            </Box>
          </CardActions>
        </Card>
      </Modal>
    </>
  );
};
